import * as React from "react";
import { Separator } from "@/components/ui/separator";
export default function TermsContent() {
  return <section id="terms-content" className="bg-background py-16 px-4 md:px-8">
      <div className="mx-auto max-w-[800px]">
        {}
        <div className="mb-16 text-center text-sm text-muted-foreground space-y-1">
          <p>BlinkLab Media — A Division of BL Events LLC</p>
          <p>1121 Broad Street, Suite 1, #1008</p>
          <p>Sumter, SC 29150</p>
          <p>hello@blinklabmedia.com</p>
          <p>803-470-4042</p>
          <p>www.blinklabmedia.com</p>
        </div>

        {}
        <div className="mb-10">
          <h3 className="mb-6 font-default text-2xl font-bold text-foreground">
            1. Deposit & Payment Policy
          </h3>
          <div className="space-y-4 text-base leading-[1.8] text-muted-foreground">
            <p>
              All projects require a non-refundable 50% deposit before any design work begins. 
              The remaining balance is due upon project completion and before the final website 
              is made live or delivered to the client.
            </p>
            <p>
              Payment plans are available on projects of $1,000 or more. Payment plan terms 
              will be outlined in your individual project agreement.
            </p>
            <p>
              Accepted payment methods: Credit Card, Debit Card, PayPal, Zelle, Cash App, 
              and Stripe Invoicing.
            </p>
          </div>
        </div>

        <Separator className="my-10 bg-border" />

        {}
        <div className="mb-10">
          <h3 className="mb-6 font-default text-2xl font-bold text-foreground">
            2. Refund Policy
          </h3>
          <div className="space-y-4 text-base leading-[1.8] text-muted-foreground">
            <p className="font-bold text-foreground uppercase">
              ALL DEPOSITS ARE NON-REFUNDABLE.
            </p>
            <p>
              Once a deposit is received, BlinkLab Media immediately begins allocating time, 
              resources, and tools to your project. For this reason, deposits cannot be 
              returned under any circumstances once work has commenced.
            </p>
            <p>
              <strong className="text-foreground">FULL PAYMENTS:</strong>
              <br />
              If a client has paid in full and BlinkLab Media has not yet begun work, 
              a refund minus a 25% administrative fee may be issued within 48 hours of payment. 
              After 48 hours or once work has begun, no refund will be issued.
            </p>
            <p>
              <strong className="text-foreground">PARTIAL REFUNDS:</strong>
              <br />
              No partial refunds will be issued for completed phases of a project. 
              If a client chooses to discontinue a project mid-way, all payments made 
              for completed work are non-refundable.
            </p>
            <p>
              <strong className="text-foreground">MONTHLY CARE PLANS & SOCIAL MEDIA SERVICES:</strong>
              <br />
              Monthly recurring services may be cancelled with 30 days written notice. 
              No refunds will be issued for the current billing month. 
              Cancellations take effect at the start of the next billing cycle.
            </p>
            <p>
              <strong className="text-foreground">CONTENT CALENDARS & DIGITAL DELIVERABLES:</strong>
              <br />
              Due to the digital nature of content calendars, social media packages, and 
              other downloadable deliverables, all sales are final once the deliverable 
              has been sent to the client.
            </p>
          </div>
        </div>

        <Separator className="my-10 bg-border" />

        {}
        <div className="mb-10">
          <h3 className="mb-6 font-default text-2xl font-bold text-foreground">
            3. Client Change of Mind Policy
          </h3>
          <div className="space-y-4 text-base leading-[1.8] text-muted-foreground">
            <p>
              BlinkLab Media understands that business needs can change. However, the following 
              policy applies to all project cancellations or scope changes initiated by the client.
            </p>
            <p>
              <strong className="text-foreground">BEFORE WORK BEGINS:</strong>
              <br />
              If a client wishes to cancel after paying a deposit but before any design work has 
              started, the deposit remains non-refundable. However, BlinkLab Media will apply the 
              deposit as a credit toward a future project if rescheduled within 90 days.
            </p>
            <p>
              <strong className="text-foreground">AFTER WORK HAS BEGUN:</strong>
              <br />
              Once BlinkLab Media has begun design, development, or content creation:
            </p>
            <p>
              The deposit is fully forfeited.
              <br />
              Any additional payments made are non-refundable for work already completed.
              <br />
              The client will receive all completed work files up to the point of cancellation.
              <br />
              No further work will be performed without a new agreement and payment.
            </p>
            <p>
              <strong className="text-foreground">SCOPE CHANGES DURING A PROJECT:</strong>
              <br />
              Changes to the original project scope — including adding pages, features, 
              or services not included in the original agreement — will be quoted separately 
              and require written approval and additional payment before the new work begins.
            </p>
          </div>
        </div>

        <Separator className="my-10 bg-border" />

        {}
        <div className="mb-10">
          <h3 className="mb-6 font-default text-2xl font-bold text-foreground">
            4. Revision Policy
          </h3>
          <div className="space-y-4 text-base leading-[1.8] text-muted-foreground">
            <p>
              Each package includes a set number of revision rounds as follows:
            </p>
            <p>
              Starter Site: 1 round of revisions
              <br />
              Professional Site: 2 rounds of revisions
              <br />
              Business Pro: 3 rounds of revisions
            </p>
            <p>
              A revision round is defined as one consolidated list of changes submitted 
              by the client at one time. Revisions must be submitted within 7 days of 
              receiving the design preview.
            </p>
            <p>
              Revisions requested beyond the included rounds will be billed at $75 per 
              revision session.
            </p>
            <p>
              Revisions do not include new features, additional pages, or redesigns. 
              These are treated as new project scope and will be quoted separately.
            </p>
          </div>
        </div>

        <Separator className="my-10 bg-border" />

        {}
        <div className="mb-10">
          <h3 className="mb-6 font-default text-2xl font-bold text-foreground">
            5. Client Responsibilities
          </h3>
          <div className="space-y-4 text-base leading-[1.8] text-muted-foreground">
            <p>
              The client is responsible for providing all necessary materials in a timely manner, 
              including but not limited to:
            </p>
            <p>
              Business information and descriptions
              <br />
              Copy and written content (if not purchasing copywriting services)
              <br />
              Logo files if applicable
              <br />
              Photos and media assets if applicable
              <br />
              Timely feedback and revision requests
              <br />
              Login credentials for domain and hosting if transferring an existing site
            </p>
            <p>
              BlinkLab Media is not responsible for project delays caused by the client's 
              failure to provide required materials or timely approvals.
            </p>
            <p>
              If a client does not respond or provide required materials for 30 consecutive days, 
              the project will be marked inactive. Reactivating an inactive project may 
              require an additional restart fee of $75.
            </p>
          </div>
        </div>

        <Separator className="my-10 bg-border" />

        {}
        <div className="mb-10">
          <h3 className="mb-6 font-default text-2xl font-bold text-foreground">
            6. Delivery & Launch Policy
          </h3>
          <div className="space-y-4 text-base leading-[1.8] text-muted-foreground">
            <p>
              Estimated delivery timelines begin only after receipt of the deposit AND all 
              required client materials.
            </p>
            <p>
              Delivery estimates are as follows:
              <br />
              Starter Site: 3 to 5 business days
              <br />
              Professional Site: 5 to 7 business days
              <br />
              Business Pro: 10 to 14 business days
            </p>
            <p>
              These are estimates and not guarantees. Timelines may be affected by client 
              response time, revision requests, or third-party integrations beyond our control.
            </p>
            <p>
              The final website will not be made live or transferred to the client until the 
              final payment has been received in full.
            </p>
          </div>
        </div>

        <Separator className="my-10 bg-border" />

        {}
        <div className="mb-10">
          <h3 className="mb-6 font-default text-2xl font-bold text-foreground">
            7. Intellectual Property
          </h3>
          <div className="space-y-4 text-base leading-[1.8] text-muted-foreground">
            <p>
              Upon receipt of final payment in full, the client owns all design files and 
              content created specifically for their project by BlinkLab Media.
            </p>
            <p>
              BlinkLab Media retains the right to display completed work in its portfolio, 
              website, marketing materials, and social media unless the client requests 
              otherwise in writing prior to project completion.
            </p>
            <p>
              Third-party assets such as stock photos, fonts, and plugins remain subject to 
              their respective licensing agreements.
            </p>
          </div>
        </div>

        <Separator className="my-10 bg-border" />

        {}
        <div className="mb-10">
          <h3 className="mb-6 font-default text-2xl font-bold text-foreground">
            8. Limitation of Liability
          </h3>
          <div className="space-y-4 text-base leading-[1.8] text-muted-foreground">
            <p>
              BlinkLab Media, a division of BL Events LLC, shall not be held liable for any indirect, 
              incidental, or consequential damages arising from the use of delivered services, 
              including but not limited to loss of revenue, loss of data, or business interruption.
            </p>
            <p>
              Our total liability to any client shall not exceed the total amount paid by 
              that client for the specific service in question.
            </p>
            <p>
              BlinkLab Media does not guarantee specific results from any website, 
              social media service, or digital marketing campaign. 
              Results vary based on industry, market, and client participation.
            </p>
          </div>
        </div>

        <Separator className="my-10 bg-border" />

        {}
        <div className="mb-10">
          <h3 className="mb-6 font-default text-2xl font-bold text-foreground">
            9. Governing Law
          </h3>
          <div className="space-y-4 text-base leading-[1.8] text-muted-foreground">
            <p>
              These Terms of Service shall be governed by and construed in accordance with the 
              laws of the State of South Carolina. Any disputes arising from services 
              provided by BlinkLab Media shall be resolved in Sumter County, South Carolina.
            </p>
            <p>
              If any provision of these Terms is found to be unenforceable, the remaining 
              provisions will continue in full force and effect.
            </p>
          </div>
        </div>

        <Separator className="my-10 bg-border" />

        {}
        <div className="mb-10">
          <h3 className="mb-6 font-default text-2xl font-bold text-foreground">
            10. Contact & Dispute Resolution
          </h3>
          <div className="space-y-4 text-base leading-[1.8] text-muted-foreground">
            <p>
              BlinkLab Media is committed to resolving all client concerns professionally 
              and promptly. Before initiating any formal dispute, we ask that clients 
              contact us directly so we can work toward a resolution together.
            </p>
            <p>
              To reach us:
            </p>
            <p>
              Email: hello@blinklabmedia.com
              <br />
              Billing inquiries: billing@blinklabmedia.com
              <br />
              Phone: 803-470-4042
              <br />
              Website: www.blinklabmedia.com
              <br />
              Mailing Address:
              <br />
              BlinkLab Media — A Division of BL Events LLC
              <br />
              1121 Broad Street, Suite 1, #1008
              <br />
              Sumter, SC 29150
            </p>
            <p>
              By submitting payment to BlinkLab Media you confirm that you have read, 
              understood, and agree to these Terms of Service in full.
            </p>
          </div>
        </div>
      </div>
    </section>;
}